export default __webpack_public_path__ + "static/media/nft.b649d49d.png";